import { Link, SecondaryNavigationMenuItem } from "melco-ui";
import styled from "styled-components";

const StyledHelpLink = styled(Link)`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HelpLink: React.FC = () => {
  return (
    <SecondaryNavigationMenuItem>
      <StyledHelpLink
        href={`${process.env.REACT_APP_HELP_URL!}`}
        data-cy-id="help-link"
        target="_blank"
      >
        ?
      </StyledHelpLink>
    </SecondaryNavigationMenuItem>
  );
};
